function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { SvgIcon } from '@material-ui/core';
export default function BellIcon(props) {
  let output = /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M772.454 613.056c-62.428-62.428-143.318-99.664-230.358-106.658v-61.422h58.094v-60.196h-176.386v60.196h58.094v61.422c-87.040 6.992-167.932 44.23-230.36 106.658s-99.664 143.32-106.656 230.358h734.228c-6.988-87.040-44.228-167.934-106.656-230.358z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M841.798 963.804v-60.196h-659.016v60.196h-94.158v60.196h846.752v-60.196z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M481.906 0h60.196v126.332h-60.196v-126.332z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M795.706 396.37h128.698v60.196h-128.698v-60.196z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M99.58 396.37h127.92v60.196h-127.92v-60.196z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M790.854 105.046l-0.434 0.438-91.070 91.070 42.564 42.564 91.506-91.508z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M233.174 105.074l-20.458 20.456-22.478 21.732 21.652-20.906-21.282 21.282 91.072 91.070 42.564-42.564z"
  })));
  return output;
}
